import './library-media-labels.component.less'

/** A label needs a name. Spaces alone are not a name. */
function hasName (label) {
  return typeof label.name === 'string' && label.name.trim() !== ''
}

class LibraryMediaLabelsController {
  constructor ($log, $scope, BulkApplyService, MediaLabelService, ColorService) {
    'ngInject'

    this._$log = $log
    this._BulkApplyService = BulkApplyService
    this._MediaLabelService = MediaLabelService
    this._ColorService = ColorService

    this.editingId = false
    this.isLabelsCollapsed = false
    this.newLabel = this._generatePlaceholderLabel()
    this.colors = this._ColorService.getColors()

    this.MediaLabels = MediaLabelService.getAll()
    const unsubscribe = MediaLabelService.subscribe(state => {
      this.MediaLabels = state.MediaLabels
    })

    $scope.$on('$destroy', unsubscribe)
  }

  _generatePlaceholderLabel () {
    return {
      name: '',
      color: this._ColorService.getRandomColor()
    }
  }

  toggleEdit (labelId) {
    if (this.editingId === labelId) {
      this.editingId = false
    } else {
      this.editingId = labelId
    }
  }

  _editingLabel () {
    return this.MediaLabels.find(mediaLabel => mediaLabel.id === this.editingId)
  }

  // The server keeps the old name when the new name is empty, so a rename to
  // nothing would close the fields and show no change. The check is off instead.
  canSaveLabel () {
    const mediaLabel = this._editingLabel()
    return Boolean(mediaLabel) && hasName(mediaLabel)
  }

  saveLabel () {
    if (!this.canSaveLabel()) {
      return
    }
    const mediaLabel = this._editingLabel()
    this._MediaLabelService.update({ ...mediaLabel, name: mediaLabel.name.trim() })
      .then(() => this.toggleEdit(this.editingId))
      .catch(error => this._$log.error(`Unable to save the label: ${error.message}`))
  }

  canCreateLabel () {
    return hasName(this.newLabel)
  }

  // The server rejects a label with no name. The check and the Enter key both
  // come here, so the guard is here and not only on the button. The new label
  // stays in the fields when the server rejects it, so the operator can try again.
  createLabel () {
    if (!this.canCreateLabel()) {
      return
    }
    this._MediaLabelService.create({ ...this.newLabel, name: this.newLabel.name.trim() })
      .then(() => this.resetNewLabel())
      .catch(error => this._$log.error(`Unable to create the label: ${error.message}`))
  }

  resetNewLabel () {
    this.newLabel = this._generatePlaceholderLabel()
  }

  deleteLabel (labelId) {
    if (confirm('This action deletes the label, are you sure?')) {
      this._MediaLabelService.delete(labelId)
    }
  }

  applyLabel (labelId) {
    const elementsToLabel = [];

    ['serviceannouncements', 'socialmediasources', 'filemedias']
      .forEach(namespace => {
        this._BulkApplyService
          .getSelectedElements(namespace)
          .forEach(mediaId => elementsToLabel.push({ namespace, mediaId, labelId }))
      })

    // Elements have been selected, add labels
    if (elementsToLabel.length > 0) {
      elementsToLabel.forEach(element =>
        this._MediaLabelService.addLabel(element.namespace, element.mediaId, element.labelId))
    }

    // Reset all bulk-select
    this._BulkApplyService.bulkSelectReset()
  }
}

export default {
  controller: LibraryMediaLabelsController,
  template: require('./library-media-labels.component.html').default
}
